import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7db1cdbd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "checkbox-container" }
const _hoisted_2 = { class: "checkbox" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Advanced mode ")
const _hoisted_4 = { class: "control" }
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "control" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "field has-addons" }
const _hoisted_11 = { class: "control" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: null
}, "Theme", -1))
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "control" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { class: "column-2" }
const _hoisted_19 = { class: "column-2" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Transform", -1))
const _hoisted_21 = { class: "field has-addons" }
const _hoisted_22 = { class: "control is-expanded" }
const _hoisted_23 = { class: "control" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1))
const _hoisted_25 = [
  _hoisted_24
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PanelAttribute = _resolveComponent("PanelAttribute")!
  const _component_PanelSection = _resolveComponent("PanelSection")!
  const _component_FormatInput = _resolveComponent("FormatInput")!
  const _component_TransfoPackageInput = _resolveComponent("TransfoPackageInput")!
  const _component_StylesheetEditor = _resolveComponent("StylesheetEditor")!
  const _component_DimensionInput = _resolveComponent("DimensionInput")!
  const _component_TransformEditor = _resolveComponent("TransformEditor")!
  const _component_PreserveAspectRatioInput = _resolveComponent("PreserveAspectRatioInput")!
  const _component_LineConfigurationsEditor = _resolveComponent("LineConfigurationsEditor")!
  const _component_MonacoWrapper = _resolveComponent("MonacoWrapper")!
  const _component_CroppingsEditor = _resolveComponent("CroppingsEditor")!
  const _component_JsonEditor = _resolveComponent("JsonEditor")!
  const _component_Panel = _resolveComponent("Panel")!

  return (_openBlock(), _createBlock(_component_Panel, { title: "Properties" }, {
    default: _withCtx(() => [
      ((_ctx.selectionType === 'spread' || _ctx.selectionType === 'layer') && _ctx.selection)
        ? (_openBlock(), _createBlock(_component_PanelSection, {
            key: 0,
            title: "Name"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_PanelAttribute, { title: "Name" }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("input", {
                    class: "input is-small",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.selection.name = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.selection.name]
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.selectionType === 'spread' && _ctx.selection)
        ? (_openBlock(), _createBlock(_component_PanelSection, {
            key: 1,
            title: "Format"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_PanelAttribute, { title: "Format" }, {
                default: _withCtx(() => [
                  _createVNode(_component_FormatInput, {
                    modelValue: _ctx.selection.format,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selection.format = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.isSelectionLayerWithType('transfo-svg'))
        ? (_openBlock(), _createBlock(_component_PanelSection, {
            key: 2,
            title: "Transfo Package"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_PanelAttribute, { title: "Package" }, {
                default: _withCtx(() => [
                  _createVNode(_component_TransfoPackageInput, { layer: _ctx.selection }, null, 8, ["layer"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.isSelectionLayer && _ctx.selection.styling)
        ? (_openBlock(), _createBlock(_component_PanelSection, {
            key: 3,
            title: "Styling"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("label", _hoisted_2, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    class: "checkbox",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.stylingAdvancedMode = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.stylingAdvancedMode]
                  ]),
                  _hoisted_3
                ])
              ]),
              (_ctx.selection.styling)
                ? (_openBlock(), _createBlock(_component_PanelAttribute, {
                    key: 0,
                    title: "Themes"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selection.styling.themes || [], (theme) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "field has-addons",
                          key: theme
                        }, [
                          _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("input", {
                              class: "input is-small",
                              readonly: "",
                              value: theme
                            }, null, 8, _hoisted_5)
                          ]),
                          _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("button", {
                              class: "button is-small",
                              onClick: ($event: any) => (_ctx.removeTheme(theme))
                            }, _hoisted_9, 8, _hoisted_7)
                          ])
                        ]))
                      }), 128)),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _withDirectives(_createElementVNode("select", {
                            class: "select is-small",
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.newTheme = $event))
                          }, [
                            _hoisted_12,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableThemes, (theme) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: theme.name,
                                value: theme.name
                              }, _toDisplayString(theme.name), 9, _hoisted_13))
                            }), 128))
                          ], 512), [
                            [_vModelSelect, _ctx.newTheme]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("button", {
                            class: "button is-small",
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.addTheme())),
                            disabled: !_ctx.newTheme
                          }, _hoisted_17, 8, _hoisted_15)
                        ])
                      ])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.stylingAdvancedMode && _ctx.selection.styling.stylesheet)
                ? (_openBlock(), _createBlock(_component_PanelAttribute, {
                    key: 1,
                    title: "Stylesheet",
                    expandable: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_StylesheetEditor, {
                        modelValue: _ctx.selection.styling.stylesheet,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.selection.styling.stylesheet = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (!_ctx.stylingAdvancedMode && _ctx.selection.styling.stylesheet)
                ? (_openBlock(), _createBlock(_component_PanelAttribute, {
                    key: 2,
                    title: "Stylesheet"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_18, [
                        _createVNode(_component_DimensionInput, {
                          class: "dimension-input",
                          modelValue: _ctx.selection.styling.stylesheet['width'],
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.selection.styling.stylesheet['width'] = $event)),
                          label: "Width"
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_DimensionInput, {
                          class: "dimension-input",
                          modelValue: _ctx.selection.styling.stylesheet['min-width'],
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.selection.styling.stylesheet['min-width'] = $event)),
                          label: "Min"
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_DimensionInput, {
                          class: "dimension-input",
                          modelValue: _ctx.selection.styling.stylesheet['max-width'],
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.selection.styling.stylesheet['max-width'] = $event)),
                          label: "Max"
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_19, [
                        _createVNode(_component_DimensionInput, {
                          class: "dimension-input",
                          modelValue: _ctx.selection.styling.stylesheet['height'],
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.selection.styling.stylesheet['height'] = $event)),
                          label: "Height"
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_DimensionInput, {
                          class: "dimension-input",
                          modelValue: _ctx.selection.styling.stylesheet['min-height'],
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.selection.styling.stylesheet['min-height'] = $event)),
                          label: "Min"
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_DimensionInput, {
                          class: "dimension-input",
                          modelValue: _ctx.selection.styling.stylesheet['max-height'],
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.selection.styling.stylesheet['max-height'] = $event)),
                          label: "Max"
                        }, null, 8, ["modelValue"])
                      ]),
                      _hoisted_20,
                      _createVNode(_component_TransformEditor, {
                        modelValue: _ctx.selection.styling.stylesheet['transform'],
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.selection.styling.stylesheet['transform'] = $event)),
                        layer: _ctx.selection
                      }, null, 8, ["modelValue", "layer"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.isSelectionLayerWithType('transfo-svg') && _ctx.selection.styling)
                ? (_openBlock(), _createBlock(_component_PanelAttribute, {
                    key: 3,
                    title: "Preserve Aspect Ratio"
                  }, {
                    default: _withCtx(() => [
                      (!_ctx.stylingAdvancedMode)
                        ? (_openBlock(), _createBlock(_component_PreserveAspectRatioInput, {
                            key: 0,
                            modelValue: _ctx.selection.styling.preserveAspectRatio,
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.selection.styling.preserveAspectRatio = $event))
                          }, null, 8, ["modelValue"]))
                        : _createCommentVNode("", true),
                      (_ctx.stylingAdvancedMode)
                        ? _withDirectives((_openBlock(), _createElementBlock("input", {
                            key: 1,
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.selection.styling.preserveAspectRatio = $event)),
                            class: "input is-small code-input",
                            autocomplete: "off",
                            autocorrect: "off",
                            autocapitalize: "off",
                            spellcheck: "false"
                          }, null, 512)), [
                            [_vModelText, _ctx.selection.styling.preserveAspectRatio]
                          ])
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.isSelectionLayerWithType('text'))
        ? (_openBlock(), _createBlock(_component_PanelSection, {
            key: 4,
            title: "Text"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_PanelAttribute, {
                title: "Text",
                expandable: ""
              }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("textarea", {
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.selection.text = $event)),
                    class: "textarea is-small",
                    autocomplete: "off",
                    autocorrect: "off",
                    autocapitalize: "off",
                    spellcheck: "false"
                  }, null, 512), [
                    [_vModelText, _ctx.selection.text]
                  ])
                ]),
                _: 1
              }),
              (_ctx.isSelectionLayerWithType('text'))
                ? (_openBlock(), _createBlock(_component_PanelAttribute, {
                    key: 0,
                    title: "Line Configurations"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_LineConfigurationsEditor, {
                        modelValue: _ctx.selection.lineConfigurations,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.selection.lineConfigurations = $event)),
                        text: _ctx.selection.text,
                        advancedMode: _ctx.stylingAdvancedMode
                      }, null, 8, ["modelValue", "text", "advancedMode"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.isSelectionLayerWithType('html'))
        ? (_openBlock(), _createBlock(_component_PanelSection, {
            key: 5,
            title: "Html"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_PanelAttribute, {
                title: "Html",
                expandable: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_MonacoWrapper, {
                    modelValue: _ctx.selection.html,
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.selection.html = $event)),
                    language: "html",
                    adjustToContent: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.isSelectionSpread || _ctx.isSelectionLayer)
        ? (_openBlock(), _createBlock(_component_PanelSection, {
            key: 6,
            title: "Condition"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_PanelAttribute, { title: "Condition" }, {
                default: _withCtx(() => [
                  (!_ctx.selection.condition)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "button is-small",
                        onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.selection.condition = {}))
                      }, " Add condition "))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      (_ctx.selection.condition)
                        ? _withDirectives((_openBlock(), _createElementBlock("input", {
                            key: 0,
                            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.selection.condition.expression = $event)),
                            class: "input is-small code-input",
                            autocomplete: "off",
                            autocorrect: "off",
                            autocapitalize: "off",
                            spellcheck: "false",
                            placeholder: "r.theme == 'ninja'"
                          }, null, 512)), [
                            [_vModelText, _ctx.selection.condition.expression]
                          ])
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      (_ctx.selection.condition)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "button is-small",
                            onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.selection.condition = undefined))
                          }, _hoisted_25))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.isSelectionSpread)
        ? (_openBlock(), _createBlock(_component_PanelSection, {
            key: 7,
            title: "Croppings"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_PanelAttribute, {
                title: "Croppings",
                expandable: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CroppingsEditor, {
                    modelValue: _ctx.selection.croppings,
                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.selection.croppings = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.isSelectionBook)
        ? (_openBlock(), _createBlock(_component_PanelSection, {
            key: 8,
            title: "Raw",
            visible: false
          }, {
            default: _withCtx(() => [
              _createVNode(_component_PanelAttribute, {
                title: "Raw",
                expandable: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_JsonEditor, {
                    modelValue: _ctx.selection.data,
                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_ctx.setRaw($event))),
                    copyable: true
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.isSelectionSpread)
        ? (_openBlock(), _createBlock(_component_PanelSection, {
            key: 9,
            title: "Raw",
            visible: false
          }, {
            default: _withCtx(() => [
              _createVNode(_component_PanelAttribute, {
                title: "Raw",
                expandable: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_JsonEditor, {
                    modelValue: _ctx.selection,
                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (_ctx.setRaw($event))),
                    copyable: true
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.isSelectionLayer)
        ? (_openBlock(), _createBlock(_component_PanelSection, {
            key: 10,
            title: "Raw",
            visible: false
          }, {
            default: _withCtx(() => [
              _createVNode(_component_PanelAttribute, {
                title: "Raw",
                expandable: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_JsonEditor, {
                    modelValue: _ctx.selection,
                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (_ctx.setRaw($event))),
                    copyable: true
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.isSelectionView)
        ? (_openBlock(), _createBlock(_component_PanelSection, {
            key: 11,
            title: "Raw",
            visible: false
          }, {
            default: _withCtx(() => [
              _createVNode(_component_PanelAttribute, {
                title: "Raw",
                expandable: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_JsonEditor, {
                    modelValue: _ctx.selection,
                    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (_ctx.setRaw($event))),
                    copyable: true
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}